export default __webpack_public_path__ + "static/media/AccuPay-Button.54d0bdfc.png";